import { ReactElement } from 'react';

import {
  ArrowBackIosOutlined as ArrowBackIosOutlinedIcon,
  ArrowForwardIosOutlined as ArrowForwardIosOutlinedIcon
} from '@mui/icons-material';
import { useTheme, useMediaQuery } from '@mui/material';

import { ArrowProps } from './types';

import Center from '../../../../components/Center';
import IconButton from '../../../../components/IconButton';

export default function Arrow({ direction }: ArrowProps): ReactElement {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Center
      className={direction === 'prev' ? 'flicking-arrow-prev' : 'flicking-arrow-next'}
      component='span'
      sx={{
        zIndex: 100,
        position: 'absolute',
        top: isXs ? '' : '50%',
        bottom: isXs ? '30px' : '',
        left: direction === 'prev' ? '30px' : undefined,
        right: direction === 'next' ? '30px' : undefined,

        transform: 'translateY(-50%)'
      }}>
      <IconButton
        aria-label={direction === 'prev' ? 'Carousel previous button' : 'Carousel next button'}
        variant='icon'
        sx={{ color: `${theme.palette.grey[50]} !important` }}>
        {direction === 'prev' ? <ArrowBackIosOutlinedIcon /> : <ArrowForwardIosOutlinedIcon />}
      </IconButton>
    </Center>
  );
}
